// Purchase-stage TikTok pixel. Fires `PlaceAnOrder` only — `ViewContent`
// is fired by the landing pixel and is intentionally NOT re-fired here,
// since this is a purchase, not a view. `value` and `currency` both come
// from the caller, resolved from the user's actual Stripe charge — this
// is the one surface that knows the real amount, since the pricing arm
// is only settled once the subscription exists.
//
// Includes the SDK init IIFE because /post-purchase no longer inherits
// the landing-bundle scripts (route was moved out of `_marketing/` —
// see audit-cookie-trackers.md Phase 1 findings + remediation).
export function tiktokPlaceOrderScript(
  value: number,
  currency: string,
): string {
  return `
/* eslint-disable -- inline pixel script, vendor-shaped js */
!((w, _d, t) => {
  w.TiktokAnalyticsObject = t;
  const ttq = (w[t] = w[t] || []);
  ((ttq.methods = [
    'page', 'track', 'identify', 'instances', 'debug', 'on', 'off',
    'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie',
  ]),
    (ttq.setAndDefer = (t, e) => {
      t[e] = function () {
        t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
      };
    }));
  for (let i = 0; i < ttq.methods.length; i++)
    ttq.setAndDefer(ttq, ttq.methods[i]);
  ((ttq.instance = (t) => {
    const e = ttq._i[t] || [];
    for (let n = 0; n < ttq.methods.length; n++)
      ttq.setAndDefer(e, ttq.methods[n]);
    return e;
  }),
    (ttq.load = (e, n) => {
      const i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      ((ttq._i = ttq._i || {}),
        (ttq._i[e] = []),
        (ttq._i[e]._u = i),
        (ttq._t = ttq._t || {}),
        (ttq._t[e] = Date.now()),
        (ttq._o = ttq._o || {}),
        (ttq._o[e] = n || {}));
      n = document.createElement('script');
      ((n.type = 'text/javascript'),
        (n.async = !0),
        (n.src = \`\${i}?sdkid=\${e}&lib=\${t}\`));
      e = document.getElementsByTagName('script')[0];
      e.parentNode.insertBefore(n, e);
    }));
  ttq.load('CHQCEJBC77U8RIVT2S60');
  ttq.page();
})(window, document, 'ttq');
ttq.track('PlaceAnOrder', {
  contents: [{ content_id: '100', content_name: 'unlimited_listening' }],
  value: '${value}',
  currency: '${currency}',
});
`;
}
